import { useState } from "react";
import { useApp, useService, useSession } from "contexts";
import { useNavigate } from "react-router-dom";
import { useForm } from "hooks";
import { createDefaultUser, IUser } from "interfaces";
import { Enums, Routes } from "utils";
import { MessageType, SessionType } from "types";
import type { GuestType } from "components/form/guest";

export function useGuestForm(initialEmail: string, redirect: string) {
  const navigate = useNavigate();

  const { setFeedback, t } = useApp();
  const { userService } = useService();
  const { login } = useSession();

  const [current, setCurrent] = useState<GuestType>({
    email: initialEmail || "",
    first_name: "",
  });

  const { onBlur, onChange } = useForm({}, undefined, undefined, updateCallback);

  function updateCallback(name: string, value: any) {
    if (name in current) {
      setCurrent((prev) => ({ ...prev, [name]: value }));
    }
  }

  async function handleOnSubmit(event: React.FormEvent) {
    event.preventDefault();

    const response = await userService.insert({
      ...createDefaultUser(),
      first_name: current.first_name,
      email: current.email,
    } as IUser);

    if (response) {
      // TODO : improve it
      login({
        id: response._id,
        email: response.email,
        name: response.first_name + " " + response.last_name,
        role: response.role,
        settings: response.settings,
      } as SessionType);

      navigate(redirect || Routes.userdashboard);
    } else {
      setFeedback({
        message: t.message.feedback.credentials_unmatch,
        severity: Enums.EnumFeedback.Warning,
      } as MessageType);

      setCurrent({ email: "", first_name: "" });
    }
  }

  return { current, onBlur, onChange, handleOnSubmit };
}
